import React from "react";
import { Link } from "react-router-dom";

const QuickLinks = () => {
  const currentDomain = process.env.REACT_APP_SUB_DOMAIN;
  return (
    <div className="widget">
      <div className="mb-20">
        <h3 className={"widget-title"} title="Quick Links">Quick Links</h3>
        {currentDomain === "ssit" ? (
          <ul>
            <li>
              <Link to={`/${currentDomain}/workshop-conference`}>Workshop/Conference</Link>
            </li>
            <li>
              <Link to={`/${currentDomain}/downloads`}>Downloads</Link>
            </li>
            <li>
              <Link to={`/${currentDomain}/contact-us`}>Contacts</Link>
            </li>
            <li>
              <Link to={`/${currentDomain}/gallery`}>Gallery</Link>
            </li>
          </ul>
        ) : (
          <ul>
            <li>
              <a
                href="https://jntukresults.edu.in/"
                target="_blank"
                rel="noreferrer"
              >
                JNTUK Results
              </a>
            </li>
            <li>
              <a href="http://pc.jntuk.edu.in/" target="_blank" rel="noreferrer">
                JNTUK Placement Cell{" "}
              </a>
            </li>
            <li>
              <Link to="#">JNTUK Sports</Link>
            </li>
            <li>
              <Link to="#">JNTUK ARC</Link>
            </li>

            <li>
              <a href="https://jntukrd.in/" target="_blank" rel="noreferrer">
                Research & Development Cell
              </a>
            </li>
          </ul>
        )}

      </div>
    </div>
  );
};

export default QuickLinks;
